import { nanoid } from "nanoid";

const shortId = () => nanoid(11);
export const idLib = { shortId };
